import api from './auth'

// 获取消息列表
export const getMessages = (orderId) => {
  return api.get(`/work/messages/order/${orderId}`)
}

// 发送文本消息
export const sendTextMessage = (orderId, content) => {
  // 直接发送 JSON 数据，不需要 FormData
  const data = {
    message_type: 'text',
    content: content
  }

  return api.post(`/work/messages/order/${orderId}`, data, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 发送文件消息
export const sendFileMessage = async (orderId, formData, messageType = 'file') => {
  return api.post(`/work/messages/order/${orderId}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 删除消息
export const deleteMessage = (messageId) => {
  return api.delete(`/work/messages/${messageId}`)
}

// 下载文件
export const downloadFile = (messageId) => {
  return api.get(`/work/messages/${messageId}/download`, {
    responseType: 'blob'
  })
}

// 加入聊天室
export const joinChat = (orderId) => {
  return api.post(`/work/messages/order/${orderId}/join`)
}
/**
 * 标记消息为已读
 * @param {number} messageId 消息ID
 */
export function markMessageRead(messageId) {
  return api.put(`/work/messages/${messageId}/read`)
}

/**
 * 批量标记消息为已读
 * @param {Array<number>} messageIds 消息ID数组
 */
export function markMessagesRead(messageIds) {
  return api.post('/work/messages/batch-read', {
    message_ids: messageIds
  })
}

/**
 * 获取未读消息数量
 */
export function getUnreadCount() {
  return api.get('/work/messages/unread-count')
}

/**
 * 获取用户的所有未读消息
 */
export function getUnreadMessages() {
  return api.get('/work/messages/unread')
}